/**
 * @ngdoc directives
 * @memberof mercury.directives
 * @name reporttimelink
 * @description
 */
angular.module('mercury.directives.reporttimelink', [])
.directive('reporttimelink', ["reporttime", "$state", "$stateParams", function(reporttime, $state, $stateParams) {
  return {
    template: '<a ng-show="link" ng-bind="reporttimelink | reporttimeformat" ng-href="{{link}}"></a>' +
    '<span ng-hide="link" ng-bind="reporttimelink | reporttimeformat"></span>',
    restrict: 'A',
    scope: {
      reporttimelink: '='
    },
    link: function(scope, element, attrs) {
      var linkParams = angular.copy($stateParams);
      if (reporttime.reportType() == 'week' || reporttime.reportType() == 'month' || reporttime.reportType() == 'custom') {
        linkParams.report = JSON.stringify({type: 'day', time: scope.reporttimelink});

        scope.link = $state.href('.', linkParams);
      } else if (attrs.transactionsState) {
        linkParams.params = JSON.stringify({start: scope.reporttimelink, end: moment(scope.reporttimelink).add(30, 'minutes').format()});

        scope.link = $state.href(attrs.transactionsState, linkParams);
      }
    }
  };
}]);
